import { combineReducers } from 'redux'

import { makeCommunicationByIdReducer } from 'shared/utils/communication/reducer/makeCommunicationByIdReducer'
import { makeCommunicationReducer } from 'shared/utils/communication/reducer/makeCommunicationReducer'

import * as actions from '../actions'
import { IPaymentsState } from '../types'

export default combineReducers<IPaymentsState['communications']>({
  createPayout: makeCommunicationReducer(actions.createPayout),
  createDeposit: makeCommunicationByIdReducer(actions.createDeposit),
  cancelPayment: makeCommunicationByIdReducer(actions.cancelPayment),
  getDepositSystemList: makeCommunicationReducer(actions.getDepositSystemList),
  getPayoutSystemList: makeCommunicationReducer(actions.getPayoutSystemList),
  getCryptoCurrencies: makeCommunicationReducer(actions.getCryptoCurrenciesList),
  getCryptoMinAmount: makeCommunicationByIdReducer(actions.getCryptoMinAmount),
  getCryptoEstimateAmount: makeCommunicationReducer(actions.getCryptoEstimateAmount),
  uploadDocument: makeCommunicationReducer(actions.uploadDocument),
})
